'use strict';

angular.module('app.services')
.factory('roteamentoChamadoApi', roteamentoChamadoApi);

roteamentoChamadoApi.$inject = ['$resource', 'ConfigApp'];

function roteamentoChamadoApi($resource, ConfigApp) {
    return $resource(ConfigApp.UrlApi + '/v1.0/roteamentos',
        {}, {
            redirecionarPara: {
                method: 'POST',
                url: ConfigApp.UrlApi + '/v1.0/roteamentos/redirecionar/chamados/:chamadoId'
            },
            listarEnderecos: {
                method: 'GET',
                isArray: true,
                url: ConfigApp.UrlApi + '/v1.0/roteamentos/enderecos'
            },
            listarMotivos: {
                method: 'GET',
                isArray: true,
                url: ConfigApp.UrlApi + '/v1.0/roteamentos/motivos',
                cache: true
            }
        });
};


// WEBPACK FOOTER //
// ./src/services/roteamentos-api-service.js